var map = {
	"./contract_dispute.png": "0773",
	"./criminal_case.png": "85fc",
	"./debt_dispute.png": "95a8",
	"./enterprise_legal.png": "324f",
	"./family_affairs.png": "3533",
	"./intellectual_property.png": "21f9",
	"./non_litigation.png": "2710",
	"./other.png": "2672"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c916";